
const month = [{key: 'aug', name: 'Август 2020'}, {key: 'jun', name: 'Июль 2020'}, {key: 'sep', name: 'Сентябрь 2020'}, {key: 'dec', name: 'Декабрь 2020'}, {key: 'apr', name: 'Апрель 2020'} ];


export const getNormalMass = (data) => {
const x = []

for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
    const element = data[key];
    
    if (Array.isArray(element)) {
        for (const key_ in element[0]) {
        if (Object.hasOwnProperty.call(element[0], key_)) {
            const element_ = element[0][key_];
            x.push({key: month.find(el => el.key == key_)?.name, value: element_});    
        }
        }
    
    } else {
        x.push({key: key, value: data[key]});
    }
    }
}
    return x; 
}